import React, { useState, useContext, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Pathname } from 'Routes';
import { AppContext, AuthContext } from 'Context';
import { ALLOWED_UPLOADS_COUNT } from 'Commons';
import logo from 'Assets/Login Logo.png';
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import SelectPhoto from 'Assets/photo-camera.png';
import SelectVideo from 'Assets/clapperboard.png';
import { Modal } from 'Components/modal';
import styles from './index.module.css';

export const Welcome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    setAppSnackbar,
    setUpdateType,
    videoFiles,
    setVideoFiles,
    imageFiles,
    setImageFiles,
    setSingleUpload,
    setPhotoList,
    setOpen,
    subscriptionDetails,
    MAX_SIZE_GB,
    setOpenNewUploadModal,
    setShowMultipleModal,
    setSelectedFilesMulti,
    setPendingVideoFile,
    setPendingPhotoFiles,
    setOpenPhotoUploadModal,
    freePlanLimitMb,
    totalOnGoingUploadSize,
    IsfreePlan
  } = useContext(AppContext);
  const fileInputRef = useRef(null);
  const photoFileInputRef = useRef(null);
  const combinedFileInputRef = useRef(null);
  const addMoreFileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [showUploadLimitModal, setShowUploadLimitModal] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };

  const suffix = getQueryParam('email');
  const MAX_SIZE_BYTES = MAX_SIZE_GB * 1024 * 1024 * 1024;
  const onChooseFiles = () => {
    fileInputRef.current?.click();
  };

  const onChoosePhotoFiles = () => {
    photoFileInputRef.current?.click();
  };

  const onChooseCombinedFiles = () => {
    combinedFileInputRef.current?.click();
  };

  const onFiles = (f) => {
    if (!f) return;

    const filesArray = Array.from(f);
    const totalSize = filesArray.reduce((acc, file) => acc + file.size, 0);

    // if (totalSize > MAX_SIZE_BYTES) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    //   return;
    // }

    setFiles(filesArray);
  };

  const onPhotoFiles = (f) => {
    if (!f) return;

    const photoFiles = Array.from(f);
    const totalSize = photoFiles.reduce((acc, file) => acc + file.size, 0);

    // if (totalSize > MAX_SIZE_BYTES) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    //   return;
    // }

    setFiles(photoFiles);
  };

  const onCombinedFiles = (f) => {
    if (!f) return;

    const combinedFiles = Array.from(f);
    const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);

    // if (totalSize > MAX_SIZE_BYTES) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    //   return;
    // }

    setFiles(combinedFiles);
  };

  const removeFile = (indexToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
  };

  const handleDownloadUploader = () => {
    if (isButtonClicked) {
      navigate('/access');
    } else {
      window.open('https://www.projectoruploader.com/download.html', '_blank');
      setIsButtonClicked(true);
    }
  };

  const handleManualUpload = () => {
    navigate('/dashboard');
  };

  const handleContinue = () => {
    if (location.state?.isGiftFlow) {
      window.open(`${Pathname.authentication.ecosystem}?gift=true`, '_blank');
    } else {
      navigate(Pathname.access);
    }
  };

  const handleUploadPhotos = () => {
    const selectedPhotos = files.filter((file) => file.type.startsWith('image/'));
    if (selectedPhotos.length > 0) {
      // Store the photo files in global state
      setPendingPhotoFiles(selectedPhotos);
      setOpenPhotoUploadModal(true);
      navigate(Pathname.yourVideos);
    }
  };

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  const handleAddMoreFiles = () => {
    if (files.length === 0) return;

    // Determine file type based on existing files
    const hasVideos = files.some((file) => file.type.startsWith('video/'));
    const hasImages = files.some((file) => file.type.startsWith('image/'));

    // Set accept attribute based on existing file types
    if (hasVideos && !hasImages) {
      addMoreFileInputRef.current.accept = 'video/*';
    } else if (hasImages && !hasVideos) {
      addMoreFileInputRef.current.accept = 'image/*';
    } else {
      addMoreFileInputRef.current.accept = 'video/*,image/*';
    }

    addMoreFileInputRef.current?.click();
  };

  const onAddMoreFiles = (f) => {
    if (!f) return;

    const newFiles = Array.from(f);
    const totalSizeWithNewFiles = files.reduce((acc, file) => acc + file.size, 0)
                                  + newFiles.reduce((acc, file) => acc + file.size, 0);

    // if (totalSizeWithNewFiles > MAX_SIZE_BYTES) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    //   return;
    // }

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleUploadFiles = () => {
    const selectedFiles = files;
    const videoFiles = selectedFiles.filter((file) => file.type.startsWith('video/'));
    const imageFiles = selectedFiles.filter((file) => file.type.startsWith('image/'));
    if (imageFiles.length > 0 && videoFiles.length > 0) {
      // Handle mixed files - videos and photos together
      setVideoFiles(videoFiles);
      setPhotoList(
        imageFiles.map((file, index) => ({
          id: `photo-${index}`,
          name: file.name,
          title: file.name?.split('.').slice(0, -1).join('.') || '',
          description: '',
          category: '',
          visibility: 'private',
          url: URL.createObjectURL(file),
          thumbnail: URL.createObjectURL(file),
          originalFile: file,
        }))
      );
      setUpdateType('mixed');
      // Navigate to dashboard first, then open modal
      navigate(Pathname.yourVideos);
      setTimeout(() => {
        setSelectedFilesMulti(videoFiles);
        setOpenNewUploadModal(true);
        setShowMultipleModal(true);
      }, 100);
    } else if (imageFiles.length > 0 && videoFiles.length === 0) {
      // Handle photo-only uploads
      handleUploadPhotos();
    } else if (videoFiles.length > ALLOWED_UPLOADS_COUNT) {
      // If more than allowed uploads are selected, show upload limit modal
      setShowUploadLimitModal(true);
    } else if (videoFiles.length === 1) {
      // Store the video file in global state
      setPendingVideoFile(videoFiles[0]);
      setOpenNewUploadModal(true);
      navigate(Pathname.yourVideos);
    } else if (videoFiles.length > 1) {
      // For multiple videos, navigate to dashboard first then open ListingModal
      setVideoFiles(videoFiles);
      setUpdateType('video');
      navigate(Pathname.yourVideos);
            setTimeout(() => {
        setSelectedFilesMulti(videoFiles);
        setOpenNewUploadModal(true);
        setShowMultipleModal(true);
      }, 100);
    }
  };

  return (
    <div className={styles.welcomeContainer}>
      {/* Background accents */}
      <div className={styles.bgOverlay}>
        <div className={styles.bgAccent1} />
        <div className={styles.bgAccent2} />
        <div className={styles.bgCircle} />
      </div>

      <div className={styles.welcomeContentWrapper}>
        {/* Header */}
        <div className={styles.welcomeHeader}>
          <Link to={Pathname.home}>
            <img
              src={logo}
              alt="Projector Logo"
              className={styles.welcomeLogoImage}
            />
          </Link>
        </div>

        <div className={styles.welcomeTitleSection}>
          <h1 className={styles.welcomeTitle}>
            Congrats, your account is ready
          </h1>
          <p className={styles.welcomeSubtitle}>
            Select a way to upload your videos & photos
          </p>
        </div>

        {/* Choice Cards */}
        <div className={styles.cardsGrid}>
          {/* Card A: Uploader (Recommended) */}
          <div
            className={styles.uploaderCard}
            style={{
              borderRadius: '1rem',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              padding: '1.5rem',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              backdropFilter: 'blur(16px)',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <h3
                style={{
                  margin: '0 0 0 0',
                  fontSize: '2rem',
                  fontWeight: '700',
                  color: 'white',
                }}
              >
                Projector Uploader
              </h3>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  borderRadius: '9999px',
                  backgroundColor: 'rgba(16, 185, 129, 0.15)',
                  paddingLeft: '0.75rem',
                  paddingRight: '0.75rem',
                  paddingTop: '0.25rem',
                  paddingBottom: '0.25rem',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  color: '#6ee7b7',
                  border: '1px solid rgba(52, 211, 153, 0.3)',
                }}
              >
                Recommended
              </div>
            </div>

            <h2
              style={{
                marginTop: '1rem',
                fontSize: '1.5rem',
                fontWeight: '700',
                letterSpacing: '-0.025em',
              }}
            >
              Quick Setup
            </h2>
            <p
              style={{
                marginTop: '0.25rem',
                fontSize: '0.875rem',
                color: '#cbd5e1',
              }}
            >
              Find and upload your content from your computer and connected
              cloud drives.
            </p>

            {!isButtonClicked && (
              <div
                style={{
                  marginTop: '1.5rem',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                }}
              >
                <button
                  onClick={handleDownloadUploader}
                  className={styles.primaryButton}
                  aria-label="Install Projector Uploader"
                >
                  <GetAppIcon className={styles.buttonIcon} />
                  Install Projector Uploader
                </button>
              </div>
            )}

            <ul className={styles.featuresList}>
              <li>• Fast, reliable background uploads</li>
              <li>• Keep structure and metadata</li>
              <li>• Connect all your media sources — Local or cloud</li>
            </ul>
          </div>

          {/* Card B: Manual Upload */}
          <div className={styles.cardBase}>
            <h2 className={styles.manualUploadTitle}>Manual Upload</h2>
            <p className={styles.cardDescription}>
              Choose files from your device. Great for a few items.
            </p>
            <div className={styles.uploadMethodsContainer}>
              <div className={styles.uploadMethods}>
                <div className={styles.uploadMethodGroup}>
                  <button
                    onClick={onChooseFiles}
                    className={styles.fileSelectionButton}
                    disabled={files.length > 0}
                    style={{
                      opacity: files.length > 0 ? 0.5 : 1,
                      cursor: files.length > 0 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <img
                      src={SelectVideo}
                      alt="Select videos"
                      className={styles.fileSelectionIcon}
                    />
                  </button>
                  <span className={styles.uploadMethodLabel}>
                    Select Videos
                  </span>
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept="video/*"
                  className={styles.hiddenInput}
                  onChange={(e) => onFiles(e.target.files)}
                />
              </div>
              <div className={styles.uploadMethods}>
                <div className={styles.uploadMethodGroup}>
                  <button
                    onClick={onChoosePhotoFiles}
                    className={styles.fileSelectionButton}
                    disabled={files.length > 0}
                    style={{
                      opacity: files.length > 0 ? 0.5 : 1,
                      cursor: files.length > 0 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <img
                      src={SelectPhoto}
                      alt="Select photos"
                      className={styles.fileSelectionIcon}
                    />
                  </button>
                  <span className={styles.uploadMethodLabel}>
                    Select Photos
                  </span>
                </div>
                <input
                  ref={photoFileInputRef}
                  type="file"
                  multiple
                  accept="image/*"
                  className={styles.hiddenInput}
                  onChange={(e) => onPhotoFiles(e.target.files)}
                />
              </div>

              {/* Tell Your Story — opens /gift-content in a new tab. That
                  page already hosts the section recorder + folder list and
                  uses its own upload pipeline (direct addVideo call) that
                  handles MediaRecorder's webm output correctly, so we avoid
                  the standard upload modal's .mp4-only whitelist + WebM
                  duration:Infinity quirk that broke the inline flow. */}
              <div className={styles.uploadMethods}>
                <div className={styles.uploadMethodGroup}>
                  <button
                    type="button"
                    onClick={() => {
                      window.open(Pathname.giftFlow.content, '_blank', 'noopener');
                    }}
                    className={styles.fileSelectionButton}
                    aria-label="Tell Your Story"
                  >
                    <span
                      aria-hidden="true"
                      className={styles.fileSelectionIcon}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '2.2rem',
                        lineHeight: 1,
                      }}
                    >
                      🎬
                    </span>
                  </button>
                  <span className={styles.uploadMethodLabel}>
                    Tell Your Story
                  </span>
                </div>
              </div>

              {/* Hidden input for adding more files */}
              <input
                ref={addMoreFileInputRef}
                type="file"
                multiple
                className={styles.hiddenInput}
                onChange={(e) => onAddMoreFiles(e.target.files)}
              />
              {/* <div className={styles.uploadMethods}>
                <div className={styles.uploadMethodGroup}>
                  <button
                    onClick={onChooseCombinedFiles}
                    className={styles.fileSelectionButton}
                  >
                    <div className={styles.combinedIcon}>
                      <img
                        src={SelectVideo}
                        alt=""
                        className={styles.miniIcon}
                      />
                      <img
                        src={SelectPhoto}
                        alt=""
                        className={styles.miniIcon}
                      />
                    </div>
                  </button>
                  <span className={styles.uploadMethodLabel}>
                    Videos & Photos
                  </span>
                </div>
                <input
                  ref={combinedFileInputRef}
                  type="file"
                  multiple
                  accept="video/*,image/*"
                  className={styles.hiddenInput}
                  onChange={(e) => onCombinedFiles(e.target.files)}
                />
              </div> */}
            </div>
          </div>
        </div>

        {/* Selected Files Display */}
        {files.length > 0 && (
          <div className={styles.selectedFilesContainer}>
            <div className={styles.selectedFilesHeader}>
              <h3 className={styles.selectedFilesTitle}>
                Selected Files (
{files.length}
)
              </h3>
            {(() => {
              const isPlan6 = subscriptionDetails?.plans[
                  subscriptionDetails?.plans?.length - 1
                ]?.plan_id === '6';
              if (!isPlan6) return null;

              const videoFiles = files.filter((file) => file.type.startsWith('video/'));
              const imageFiles = files.filter((file) => file.type.startsWith('image/'));
              const hasOnlyVideos = videoFiles.length > 0 && imageFiles.length === 0;
                const hasOnlyImages = imageFiles.length > 0 && videoFiles.length === 0;
                const totalSizeMB = videoFiles.reduce((sum, file) => sum + (file.size / 1024 / 1024), 0);
                const totalPhotSizeMB = imageFiles.reduce((sum, photo) => sum + (photo.size / 1024 / 1024), 0);
                const usedStorage = subscriptionDetails?.storageUsed?.total_storage;
                const allFullStorage = totalSizeMB + usedStorage + totalOnGoingUploadSize;
                const exceededBy = allFullStorage - freePlanLimitMb;
              if (hasOnlyVideos && videoFiles.length > 15) {
                return (
                  <div className={styles.flexover}>
                    <p className={styles.erroText}>
                      You can only select 15 videos to upload
                    </p>
                                        {subscriptionDetails?.plans[
                      subscriptionDetails?.plans?.length - 1
                    ]?.plan_id === '6' && (
                      <button
                        onClick={() => navigate('/plans')}
                        className={styles.upgradeToPremiumButton}
                      >
                        Upgrade to Premium
                      </button>
                    )}
                  </div>
                );
              }
              if (IsfreePlan && allFullStorage > freePlanLimitMb) {
                return (
                  <div className={styles.flexover}>
                    <p className={styles.erroText}>
                      You can upload up to
                    {' '}
{Math.floor(freePlanLimitMb / 1024)}
{' '}
GB.
                    </p>
                                        {subscriptionDetails?.plans[
                      subscriptionDetails?.plans?.length - 1
                    ]?.plan_id === '6' && (
                      <button
                        onClick={() => navigate('/plans')}
                        className={styles.upgradeToPremiumButton}
                      >
                        Upgrade to Premium
                      </button>
                    )}
                  </div>
                );
              }

              // Check photo upload limits for free plan
              const isStorageLimitExceeded = hasOnlyImages && IsfreePlan && allFullStorage > freePlanLimitMb;
              const isPhotoCountExceeded = hasOnlyImages && imageFiles.length > 25;

              if (isStorageLimitExceeded) {
                return (
                  <div className={styles.flexover}>
                    <p className={styles.erroText}>
                      You can upload up to
                    {' '}
{Math.floor(freePlanLimitMb / 1024)}
{' '}
GB.
                    </p>
                    {isPlan6 && (
                      <button
                        onClick={() => navigate('/plans')}
                        className={styles.upgradeToPremiumButton}
                      >
                        Upgrade to Premium
                      </button>
                    )}
                  </div>
                );
              }

              if (isPhotoCountExceeded) {
                return (
                  <div className={styles.flexover}>
                    <p className={styles.erroText}>
                      You can only select 25 images to upload
                    </p>
                    {isPlan6 && (
                      <button
                        onClick={() => navigate('/plans')}
                        className={styles.upgradeToPremiumButton}
                      >
                        Upgrade to Premium
                      </button>
                    )}
                  </div>
                );
              }

              return null;
            })()}
            </div>
            <div className={styles.filesGrid}>
              {files.map((file, index) => (
                <div key={index} className={styles.fileItem}>
                  <button
                    onClick={() => removeFile(index)}
                    className={styles.removeFileButton}
                  >
                    <CloseIcon className={styles.closeIcon} />
                  </button>
                  <div className={styles.fileIndicator} />
                  <div className={styles.fileDetails}>
                    <div className={styles.fileName}>{file.name}</div>
                    <div className={styles.fileSize}>
                      {(file.size / (1024 * 1024)).toFixed(1)}
{' '}
MB
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.fileActions}>
              <button
                onClick={handleUploadFiles}
                className={styles.uploadButton}
              >
                Upload Files
              </button>
              {/* Add More button with conditional visibility */}
              {(() => {
                const videoFiles = files.filter((file) => file.type.startsWith('video/'));
                const imageFiles = files.filter((file) => file.type.startsWith('image/'));
                const isPlan6 = subscriptionDetails?.plans[
                    subscriptionDetails?.plans?.length - 1
                  ]?.plan_id === '6';

                if (!isPlan6) {
                  return (
                    <button
                      onClick={handleAddMoreFiles}
                      className={styles.clearButton}
                    >
                      Add More
                    </button>
                  );
                }

                // Calculate all error conditions
                const hasOnlyVideos = videoFiles.length > 0 && imageFiles.length === 0;
                const hasOnlyImages = imageFiles.length > 0 && videoFiles.length === 0;
                const totalSizeMB = videoFiles.reduce((sum, file) => sum + (file.size / 1024 / 1024), 0);
                const totalPhotSizeMB = imageFiles.reduce((sum, photo) => sum + (photo.size / 1024 / 1024), 0);
                const usedStorage = subscriptionDetails?.storageUsed?.total_storage;
                const allFullStorage = totalSizeMB + totalPhotSizeMB + usedStorage + totalOnGoingUploadSize;

                // Check all error conditions
                const isVideoCountExceeded = hasOnlyVideos && videoFiles.length > 15;
                const isVideoStorageExceeded = IsfreePlan && allFullStorage > freePlanLimitMb;
                const isPhotoStorageExceeded = hasOnlyImages && IsfreePlan && allFullStorage > freePlanLimitMb;
                const isPhotoCountExceeded = hasOnlyImages && imageFiles.length > 25;

                const hasAnyError = isVideoCountExceeded || isVideoStorageExceeded || isPhotoStorageExceeded || isPhotoCountExceeded;

                return (
                  <button
                    onClick={hasAnyError ? null : handleAddMoreFiles}
                    className={styles.clearButton}
                    disabled={hasAnyError}
                    style={{
                      opacity: hasAnyError ? 0.5 : 1,
                      cursor: hasAnyError ? 'not-allowed' : 'pointer',
                    }}
                  >
                    Add More
                  </button>
                );
              })()}
              <button
                onClick={() => setFiles([])}
                className={styles.clearButton}
              >
                Clear Selection
              </button>
            </div>
          </div>
        )}

        {/* Continue Row */}
        <div className={styles.continueSection}>
          <button className={styles.inviteButton} />
          {!location.state?.isGiftFlow && getQueryParam('gift') !== 'true' && getQueryParam('fromGift') !== 'true' && (
            <button
              onClick={() => navigate(`${Pathname.access}${suffix ? `?email=${suffix}` : ''}`)}
              className={styles.inviteButton}
            >
              Click here if you were invited to view
            </button>
          )}
          {isButtonClicked ? (
            <button
              onClick={handleContinue}
              className={styles.continueButton}
            >
              Continue
            </button>
          ) : (
            <span
              onClick={handleContinue}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleContinue();
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
              role="button"
              tabIndex={0}
              className={styles.continueLink}
            >
              Go To My Projector
            </span>
          )}
          {/* <button
            onClick={handleContinue}
            className={styles.primaryButton}
            style={{ padding: '1rem 2.5rem', fontSize: '1.1rem', background: '#2563eb', color: '#ffffff' }}
          >
            Go To My Projector
          </button> */}
        </div>
      </div>

      {/* Upload Limit Modal */}
      {showUploadLimitModal && (
        <Modal
          isVisible={showUploadLimitModal}
          onHide={() => setShowUploadLimitModal(false)}
          title="Upload Limit Exceeded"
          continueButton="Upgrade Plan"
          cancelButton="Got it"
          onContinueButtonClick={() => {
            setShowUploadLimitModal(false);
            navigate(Pathname.plans);
            // setPopUpModalVisible(true);
          }}
          onCancelButtonClick={() => setShowUploadLimitModal(false)}
        >
          <div className={styles.modalContent}>
            <div className={styles.modalIcon}>⚠️</div>
            <h3 className={styles.modalTitle}>Too Many Videos Selected</h3>
            <p className={styles.modalDescription}>
              You have selected
{' '}
              {files.filter((f) => f.type.startsWith('video/')).length}
{' '}
videos,
              but you can only upload
{' '}
{ALLOWED_UPLOADS_COUNT}
{' '}
videos with your
              current plan.
            </p>
            <p className={styles.modalFooterText}>
              Upgrade your plan to upload more videos or select fewer files to
              continue.
            </p>
          </div>
        </Modal>
      )}

    </div>
  );
};
